import type { GameProduct, GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

import { useJackpotTickerData } from 'src/hooks/useJackpotTickerData'

import { SUPPLIERS_BY_TAG } from './constants'
import { useFetchProvidersJackpots } from './hooks/useFetchProvidersJackpots'
import JackpotTicker from './JackpotTicker'

export { SUPPLIERS_BY_TAG }
export { getSupplierFromGameTags } from './utils/getSupplierFromGameTags'

export type ProviderContainerProps = {
  game: GameProduct | GameProductShort
  className?: string
}

export function JackpotTickerContainer({ game, className }: ProviderContainerProps) {
  const jackpotData = useJackpotTickerData(game)

  if (!jackpotData) {
    return null
  }

  return (
    <JackpotTicker
      amount={jackpotData.amount}
      currency={jackpotData.currency}
      className={className}
      formatMode='compactMillions'
    />
  )
}

export { useFetchProvidersJackpots }
